// shared
import {
  createFCWidgetForLogin,
  createFCWidgetForProfessionalAccountRegister,
  createFCWidgetForRegistration,
} from 'views/assets/scripts/friendlyCaptcha'
import loadingScript from 'views/assets/scripts/isFormSubmitting'
import runScripts from 'views/assets/scripts/runScripts'
import mountOneTimePasswordLoginFormContainer from 'views/containers/browser/OneTimePasswordFormContainer/mountOneTimePasswordLoginFormContainer'
import mountPasskeyFakeDoorContainer from 'views/containers/browser/PasskeyFakeDoorContainer/mountPasskeyFakeDoorContainer'
import mountProfessionalAccountRegisterFormContainer from 'views/containers/browser/ProfessionalAccountRegisterFormContainer/mountProfessionalAccountRegisterFormContainer'
import mountRegisterFormContainer from 'views/containers/browser/RegisterFormContainer/mountRegisterFormContainer'

const animateLoginButton = loadingScript({
  formSelector: '[name=login-form]',
  buttonId: 'login-submit-btn',
  transitionDurationInSec: 1,
})
runScripts(
  mountPasskeyFakeDoorContainer,
  mountOneTimePasswordLoginFormContainer,
  mountRegisterFormContainer,
  mountProfessionalAccountRegisterFormContainer,
  animateLoginButton,
  createFCWidgetForLogin,
  createFCWidgetForRegistration,
  createFCWidgetForProfessionalAccountRegister
)
